var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("header", { staticClass: "header-content" }, [
    _c(
      "div",
      {
        staticClass: "flex items-center justify-between header-bg",
        staticStyle: {
          width: "100%",
          padding: "0 80px",
          height: "80px",
          background: "rgba(7, 21, 108, 0.7)",
        },
      },
      [
        _c(
          "div",
          { staticClass: "flex items-center" },
          [
            _c("div", { staticClass: "logo-container" }, [
              _c(
                "p",
                {
                  staticClass: "logo-view flex items-center justify-center",
                  on: { click: _vm.goHome },
                },
                [
                  _c("img", {
                    attrs: {
                      src: require("@/assets/images/logo_copy2.png"),
                      alt: "",
                    },
                  }),
                ]
              ),
            ]),
            _c(
              "el-menu",
              {
                staticClass: "flex el-menu-horizontal",
                staticStyle: { "padding-left": "60px" },
                attrs: {
                  "default-active": _vm.activeRoute,
                  "background-color": "transparent",
                  mode: "horizontal",
                },
              },
              _vm._l(_vm.menuList, function (menu) {
                return _c("div", { key: menu.name }, [
                  menu.name !== "agent" && menu.name !== "writingAssistant"
                    ? _c(
                        "div",
                        [
                          !menu.children
                            ? _c(
                                "el-menu-item",
                                {
                                  attrs: { index: menu.name },
                                  on: {
                                    click: function ($event) {
                                      return _vm.clickMenuList(menu)
                                    },
                                  },
                                },
                                [
                                  _c(
                                    "span",
                                    { attrs: { slot: "title" }, slot: "title" },
                                    [_vm._v(_vm._s(menu.label))]
                                  ),
                                ]
                              )
                            : _c(
                                "el-submenu",
                                {
                                  attrs: {
                                    index: menu.name,
                                    "popper-class": "submenu-popper",
                                  },
                                },
                                [
                                  _c("template", { slot: "title" }, [
                                    _c(
                                      "span",
                                      {
                                        attrs: { slot: "title" },
                                        slot: "title",
                                      },
                                      [_vm._v(_vm._s(menu.label))]
                                    ),
                                  ]),
                                  _vm._l(menu.children, function (subItem) {
                                    return _c(
                                      "div",
                                      { key: subItem.name },
                                      [
                                        _c(
                                          "el-menu-item",
                                          {
                                            attrs: { index: subItem.name },
                                            on: {
                                              click: function ($event) {
                                                return _vm.clickMenuList(
                                                  subItem
                                                )
                                              },
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                attrs: { slot: "title" },
                                                slot: "title",
                                              },
                                              [_vm._v(_vm._s(subItem.label))]
                                            ),
                                          ]
                                        ),
                                      ],
                                      1
                                    )
                                  }),
                                ],
                                2
                              ),
                        ],
                        1
                      )
                    : menu.name === "agent" || menu.name === "writingAssistant"
                    ? _c(
                        "div",
                        {
                          staticClass: "custom-menu-item",
                          on: {
                            click: function ($event) {
                              return _vm.clickMenuList(menu)
                            },
                          },
                        },
                        [_vm._v(" " + _vm._s(menu.label) + " ")]
                      )
                    : _vm._e(),
                ])
              }),
              0
            ),
          ],
          1
        ),
        _c(
          "div",
          { staticClass: "flex items-center fileManage-userName" },
          [
            _vm.isShowFileManagement
              ? _c(
                  "div",
                  {
                    staticClass: "file-manage",
                    on: {
                      click: function ($event) {
                        return _vm.$router.push({ name: "fileManagement" })
                      },
                    },
                  },
                  [
                    _c(
                      "el-badge",
                      {
                        staticClass: "badge-dot",
                        attrs: { "is-dot": _vm.isRead },
                      },
                      [
                        _c(
                          "div",
                          {
                            staticClass: "flex items-center",
                            staticStyle: { "vertical-align": "bottom" },
                          },
                          [
                            _c("i", { staticClass: "el-icon-folder" }),
                            _c("span", { staticClass: "no-wrap" }, [
                              _vm._v("文件管理"),
                            ]),
                          ]
                        ),
                      ]
                    ),
                  ],
                  1
                )
              : _vm._e(),
            _c("el-avatar", { attrs: { size: "small", src: _vm.circleUrl } }),
            _c(
              "el-dropdown",
              { attrs: { trigger: "hover" }, on: { command: _vm.clickMenu } },
              [
                _c("span", { staticClass: "user-name no-wrap" }, [
                  _vm._v(_vm._s(_vm.userName || "admin")),
                ]),
                _c(
                  "el-dropdown-menu",
                  { attrs: { slot: "dropdown" }, slot: "dropdown" },
                  _vm._l(_vm.menu, function (item) {
                    return _c(
                      "el-dropdown-item",
                      { key: item.path, attrs: { command: item } },
                      [_vm._v(_vm._s(item.label))]
                    )
                  }),
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]
    ),
    _c("div", { staticClass: "notification-banner" }, [
      _c("div", { staticClass: "notification-content" }, [
        _c("i", { staticClass: "el-icon-warning-outline notification-icon" }),
        _c("span", { staticClass: "notification-text" }, [
          _vm._v(" 本系统已迁至新地址 "),
          _c(
            "a",
            {
              staticClass: "notification-link",
              attrs: { href: "javascript:void(0)" },
              on: { click: _vm.goToNewSystem },
            },
            [_vm._v("https://ai.zhitulist.com/achievement-ai-assistant")]
          ),
          _vm._v(
            " ，功能完全一致。当前地址不再更新，将于 2026年11月13日 关闭下线，请尽快迁移。如有问题请联系 15033960786（微信）。 "
          ),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }